module.exports = __webpack_public_path__ + "img/Leanne.2104e26e.jpg";